import { UpdateEventSettings } from '@/connection/projects/update-event-settings';
import { EventSettings } from '@/types/projects.types';
import { ProjectStateReducerCreator } from '../types';

const updateProjectSettingsReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ event_uuid, settings }: { event_uuid: string; settings: EventSettings }) => {
      try {
        const result = await UpdateEventSettings(event_uuid, settings);

        return result;
      } catch (e) {
        console.error(e);
      }
    },
    {
      pending: (state) => {
        if (state.workingProject) {
          state.isSettingsUpdating = true;
        }
      },
      fulfilled: (state, action) => {
        if (state.workingProject) {
          state.workingProject.settings = action.payload as EventSettings;
          state.isSettingsUpdating = false;
        }
      },
    }
  );
};

export default updateProjectSettingsReducer;
